<template>
	<div class="height u-m-t-20">
		<div class="widht1240">
			<div class="btm u-p-t-20">
				<span>7*24客服电话：199 1234 8021</span>
				<span>纠错电话：199 1234 7969</span>
				<span>电子邮件：982722718@qq.com</span>
			</div>
			<div class="btm">
				<a href="http://beian.miit.gov.cn/" target="_blank" rel="nofollow">ICP备案号:冀ICP备17015545号-10</a>
				<span>网站制度</span>
				<span>证照信息公示</span>
			</div>
			<div class="btm">
				<a
					href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=911302937554531049-SAIC_SHOW_1000009113029375545310491589943990227&signData=MEUCIQCzkGofkU2D1buoscP5KQEwMY+P6vAYEhXWEq75FaGcmwIgX4gQ2jbo1byAmBPyuXn/8f7pdNeQc4Olf+r6OgDBloM="
					target="_blank"
				></a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "bottominfo",
	data() {
		return {};
	},
};
</script>
<style scoped>
.height {
	/* padding-top: 45px; */
	background-color: #303849;
	padding: 50px 0;
	font-size: 16px;
}
.height .btm {
	padding: 10px 0;
}
.height span,
.height a {
	color: #d4d5d8;
	margin: 0 20px;
}
.justcontent {
	display: flex;
	align-items: center;
	justify-content: center;
}
.justcontent .el-image {
	margin-right: 10px;
}
.btm {
	color: #d4d5d8;
}
.btm span {
	margin: 0 65px;
	color: #d4d5d8;
}
.btm a {
	color: #d4d5d8;
}
.margin_botttom29 {
	/* margin-bottom: 29px; */
}
.u-m-t-20 {
	margin-top: 20px;
}
.u-p-t-20 {
	padding-top: 20px;
}
</style>